import React from "react";
import { TimeUnit } from "components/common";
const DATABASE_TYPES = {
  MAXMIND_ASN: "ASN database",
  MAXMIND_CITY: "City database",
  MAXMIND_COUNTRY: "Country database",
  IPINFO_STANDARD_LOCATION: "IPinfo location database",
  IPINFO_ASN: "IPinfo ASN database"
};
const MaxmindAdapterSummary = ({ dataAdapter: { config } }) => /* @__PURE__ */ React.createElement("dl", null, /* @__PURE__ */ React.createElement("dt", null, "Database file path"), /* @__PURE__ */ React.createElement("dd", null, config.path), /* @__PURE__ */ React.createElement("dt", null, "Database type"), /* @__PURE__ */ React.createElement("dd", null, DATABASE_TYPES[config.database_type]), /* @__PURE__ */ React.createElement("dt", null, "Check interval"), /* @__PURE__ */ React.createElement("dd", null, /* @__PURE__ */ React.createElement(TimeUnit, { value: config.check_interval, unit: config.check_interval_unit })));
export default MaxmindAdapterSummary;
